import router from './router';

//This is the this.$n function in the vue component
var formatNumber;


Date.prototype.addSeconds = function(seconds) {
  this.setSeconds(this.getSeconds() + seconds);
  return this;
};

Date.prototype.addMinutes = function(minutes) {
  this.setMinutes(this.getMinutes() + minutes);
  return this;
};

Date.prototype.addHours = function(hours) {
  this.setHours(this.getHours() + hours);
  return this;
};

Date.prototype.addDays = function(days) {
  this.setDate(this.getDate() + days);
  return this;
};

Date.prototype.addWeeks = function(weeks) {
  this.addDays(weeks*7);
  return this;
};

Date.prototype.addMonths = function (months) {
  var dt = this.getDate();
  this.setMonth(this.getMonth() + months);
  var currDt = this.getDate();
  if (dt !== currDt) {  
    this.addDays(-currDt);
  }
  return this;
};

if (!Date.prototype.toUTC){
  Date.prototype.toUTC = function(){
      var utcOffset = this.getTimezoneOffset();
      var utcNow    = this.addMinutes(utcOffset);
      return utcNow;
  };
}

const zeroDecimalCurrencies = ['JPY', 'CLP', 'KRW', 'VND', 'HUF', 'TWD', 'IDR']

export default {

  setFormatNumberFunction(formatNumberFunction) {
    formatNumber = formatNumberFunction;
  },
  uniqByKeepFirst(a, key) {
    let seen = new Set();
    return a.filter(item => {
      let k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  },
  uniqByKeepLast(a, key) {
    return [
      ...new Map(
        a.map(x => [key(x), x])
      ).values()
    ]
  },
  clone(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  duplicateAndClone(arr, times) {
    if (!times) {
      times = 1;
    }
    let newArr = this.clone(arr);
    for (let i = 0; i < times; i++) {
      newArr = newArr.concat(this.clone(arr));
    }
    return this.clone(newArr);
  },
  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  },
  fahrenheit(celsius, divider, roundMode) {
    if (roundMode) {
      return this.round((Math.round(celsius * 9 / 5) / divider) + 32, roundMode);
    }
    return (Math.round(celsius * 9 / 5) / divider) + 32;
  },
  celsius(celsius, divider, roundMode) {
    if (roundMode) {
      return this.round(celsius / divider, roundMode);
    }
    return celsius / divider;
  },
  temperature(temp, isCelsius, divider = 10, roundMode) {
    // console.log("temperature", temp, isCelsius, divider, roundMode);
    if (temp == null || temp === '') {
      return null;
    }
    if (isCelsius) {
      // return formatNumber(this.celsius(temp, divider), 'temperature');
      return formatNumber(this.celsius(temp, divider, roundMode));
    }
    // return formatNumber(this.fahrenheit(temp, divider), 'temperature');
    return formatNumber(this.fahrenheit(temp, divider, roundMode));
  },
  unit(unit, isImperial) {
    if(isImperial) {
      let imperialUnitConversion = {
        "°C": "°F",
        "mm": "in",
        "m": "ft",
        "kg": "lbs",
        "bar": "psi"
      }
      let conv = imperialUnitConversion[unit];
      if(conv!=null) {
        return conv;
      }
    }
    return unit;
  },
  unitDecimals(unit) {
    let decimals = {
      "°C": 1,
      "°F": 1,
      "mm": 0,
      "in": 2,
      "m": 2,
      "ft": 2,
      "kg": 1,
      "lbs": 1,
      "bar": 2,
      "psi": 2
    }
    let dec = decimals[unit];
    if(dec!=null) {
      return dec;
    }
    return 0;
  },
  weight(kg, isMetric) {
    if (kg == null || kg === '') {
      return null;
    }
    if (isMetric) {
      return kg;
    }
    return kg * 2.20462262185;

  },
  historyBack() {
    if (window.history.state.back == null) {
      router.push({ name: 'dashboard' });
    } else {
      router.back();
    }
  },
  crypt(salt, text) {
    const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
    const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);

    return text
      .split("")
      .map(textToChars)
      .map(applySaltToChar)
      .map(byteHex)
      .join("");
  },
  decrypt(salt, encoded) {
    const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
    const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded
      .match(/.{1,2}/g)
      .map((hex) => parseInt(hex, 16))
      .map(applySaltToChar)
      .map((charCode) => String.fromCharCode(charCode))
      .join("");
  },
  passwordCheck(value) {
    const containsUppercase = /[A-Z]/.test(value)
    const containsLowercase = /[a-z]/.test(value)
    const containsNumber = /[0-9]/.test(value)
    const containsSpecial = /[#?!@$%^&*-]/.test(value)
    return containsUppercase && containsLowercase && containsNumber && containsSpecial
  },
  taxCodeCheck(value) {
    //checks if the tax code contains only letters (uppercase or lowercase) and numbers
    const regex = /^[a-zA-Z0-9]+$/;
    return regex.test(value);
  },
  utcDate(utcTimestamp, converter) {
    return new Date(utcTimestamp * converter).toUTC();
  },
  locale(language) {
    switch(language) {
      case "de":
        return "de_DE";
      case "du":
        return "nl_NL";
      case "en":
        return "en_GB";
      case "es":
        return "es_ES";
      case "fr":
        return "fr_FR";
      case "it":
        return "it_IT";
      case "ru":
        return "ru_RU";
      case "en-US":
        return "en_US";
      case "ja":
        return "ja_JP";
      case "pt":
        return "pt_BR";
      case "ko":
        return "ko_KR";
      case "hi":
        return "hi_IN";
      case "id":
        return "id_ID";
      case "zh":
        return "zh_CN";
      default:
        return "en_GB";
    }
  },
  language(locale) {
    switch(locale) {
      case "de_DE":
      case "de":
        return "de";
      case "nl_NL":
      case "nl":
        return "du";
      case "en_GB":
      case "en":
        return "en";
      case "es_ES":
      case "es":
        return "es";
      case "fr_FR":
      case "fr":
        return "fr";
      case "it_IT":
      case "it":
        return "it";
      case "ru_RU":
      case "ru":
        return "ru";
      case "en_US":
        return "en-US";
      case "ja_JP":
      case "ja":
        return "ja";
      case "pt_BR":
      case "pt":
        return "pt";
      case "ko_KR":
      case "ko":
        return "ko";
      case "hi_IN":
      case "hi":
        return "hi";
      case "id_ID":
      case "id":
        return "id";
      case "zh_CN":
      case "zh":
        return "zh";
      default:
        return "en";
    }
  },
  compareStrings(a, b, field) {
    const stringA = field ? a[field]?.toUpperCase() : a?.toUpperCase(); // ignore upper and lowercase
    const stringB = field ? b[field]?.toUpperCase() : b?.toUpperCase(); // ignore upper and lowercase
    if (stringA < stringB) {
      return -1;
    }
    if (stringA > stringB) {
      return 1;
    }
    // names must be equal
    return 0;
  },
  compareNumbers(a, b, field) {
    const numberA = field ? a[field] : a;
    const numberB = field ? b[field] : b;
    return numberB - numberA;
  },
  compareVersionStrings(versionA, versionB) {
    // Normalizza versioni nel formato "vX.Y.Z" o "vX.Y"
    // Ritorna: negativo se A < B, 0 se A === B, positivo se A > B
    // Ritorna null se input è null/undefined/empty
    if (!versionA || !versionB) return null;
    
    // Rimuovi prefisso 'v' se presente (case-insensitive)
    const normalize = (v) => v.toLowerCase().replace(/^v/, '');
    const aStr = normalize(versionA);
    const bStr = normalize(versionB);
    
    // Split per '.' e converti in intero
    const aParts = aStr.split('.').map(p => parseInt(p) || 0);
    const bParts = bStr.split('.').map(p => parseInt(p) || 0);
    
    // Confronta segmento per segmento
    const maxLen = Math.max(aParts.length, bParts.length);
    for (let i = 0; i < maxLen; i++) {
      const aPart = aParts[i] || 0;
      const bPart = bParts[i] || 0;
      if (aPart < bPart) return -1;
      if (aPart > bPart) return 1;
    }
    
    return 0; // Versioni identiche
  },
  getColorByIdFromPalette(index){
    let palette = [
      "#D64444",
      "#4453D6",
      "#44D653",
      "#8D44D6",
      "#B9D644",
      // "#61D644",
      "#D64470",
      "#447ED6",
      // "#44D67E",
      "#D69C44",
      "#6144D6",
      // "#D6449C",
      // "#8DD644",
      "#D67044",
      "#44AAD6",
      "#D644C7",
      "#44D6AA",
      // "#B944D6",
      // "#44D6D6"
    ];
    let indexPalette = (index > (palette.length - 1)) ? (index % (palette.length -1)) : index;
    return palette[indexPalette];
  },
  isMobile() {
      if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) {
         return true ;
      } else {
         return false ;
      }
  },
  fixModelName(name) {
    if(name == null) {
      return "";
    }
    return name
      .replace("MF Next", "MultiFresh® Next")
      .replace("CP Multi", "CP Next Multi")
      .replace("CP Up", "CP Next Up")
      .replace("CK Multi", "CK Next Multi")
      .replace("CK Up", "CK Next Up")
      .replace("MYA MF", "MultiFresh® MyA")
      .replace("MP Next One", "MultiProof Next")
      .replace("SF 5T", "SimplyFresh")
      .replace("PRIME", "Prime");
  },
  fixGamma(gamma) {
    if(gamma == null) {
      return "";
    }
    return gamma
      .replace("MF Next", "MultiFresh® Next")
      .replace("CP", "CP Next")
      .replace("CK", "CK Next")
      .replace("MYA", "MultiFresh® MyA")
      .replace("MP Next", "MultiProof Next")
      .replace("SF", "SimplyFresh")
      .replace("PRIME", "Prime");
  },
  round(value, mode, decimals = 0) {
    const factor = Math.pow(10, decimals);
    if (mode === 'up') {
      return Math.ceil(value * factor) / factor;
    } else if (mode === 'down') {
      return Math.floor(value * factor) / factor;
    } else {
      console.error('Mode must be "up" or "down"');
      return value;
    }
  },
  extractChartData(adminChart) {
    if (!adminChart) return null;
    const cloned = JSON.parse(JSON.stringify(adminChart));
    // delete cloned.type;
    // delete cloned.chartOpt;
    // return cloned;
    return {
        labels: cloned.labels,
        datasets: cloned.datasets
    };
  },
  extractChartOptions(adminChart) {
    if (!adminChart) return null;
    const cloned = JSON.parse(JSON.stringify(adminChart));
    return cloned.chartOpt;
  },
  isDemoMode(email) {
    return email==null || email.toLowerCase()=='new.experienceroom@gmail.com';
  },
  alarmTooltip(alarms, translator) {
    let text = "";
    if(alarms && alarms.length>0) {
      for(let i=0; i<alarms.length; i++) {
        // if(alarms[i].active) {
          text += translator('alarms.'+alarms[i].name) + "\n";
        // } 
      }
    }
    return text;
  },
  documentLanguages() {
    return {
      "MULTI": { "flag": null, "name": "MULTI" },
      "IT": { "flag": "it", "name": "Italiano" },
      "EN": { "flag": "gb", "name": "English" },
      "FR": { "flag": "fr", "name": "Français" },
      "DE": { "flag": "de", "name": "Deutsch" },
      "ES": { "flag": "es", "name": "Español" },
      "RU": { "flag": "ru", "name": "Русский" },
      "AR": { "flag": "sa", "name": "العربية", "rtl": true },
      "CS": { "flag": "cz", "name": "Čeština" },
      "HR": { "flag": "hr", "name": "Hrvatski" },
      "HU": { "flag": "hu", "name": "Magyar" },
      "ID": { "flag": "id", "name": "Bahasa Indonesia" },
      "JP": { "flag": "jp", "name": "日本語" },
      "KO": { "flag": "kr", "name": "한국어" },
      "LT": { "flag": "lt", "name": "Lietuvių" },
      "LV": { "flag": "lv", "name": "Latviešu" },
      "NL": { "flag": "nl", "name": "Nederlands" },
      "PL": { "flag": "pl", "name": "Polski" },
      "PT": { "flag": "pt", "name": "Português" },
      "RO": { "flag": "ro", "name": "Română" },
      "TH": { "flag": "th", "name": "ไทย" },
      "TR": { "flag": "tr", "name": "Türkçe" },
      "UA": { "flag": "ua", "name": "Українська" },
      "ZH": { "flag": "cn", "name": "中文" }
    };
  },
  documentIcon(link) {
    if(link==null) {
      return "pi-ban";
    }
    let fileName = link.split('/').pop().split('?')[0];
    let fileExtension = fileName.split('.').pop();
    const ext = fileExtension.toLowerCase();
    if(ext==="pdf") {
      return "pi-file-pdf";
    } else if(ext==="doc" || ext==="docx") {
      return "pi-file-word";
    } else if(ext==="xls" || ext==="xlsx") {
      return "pi-file-excel";
    } else if(ext==="ppt" || ext==="pptx") {
      return "pi-file";
    } else if(ext==="txt") {
      return "pi-file";
    } else if(ext==="zip" || ext==="rar" || ext==="7z") {
      return "pi-file";
    } else if(ext==="mp4" || ext==="avi" || ext==="mov" || ext==="wmv" || ext==="flv" || ext==="mkv") {
      return "pi-video";
    } else if(ext==="png" || ext==="jpg" || ext==="jpeg" || ext==="gif" || ext==="bmp" || ext==="tiff" || ext==="svg") {
      return "pi-image";
    } else {
      return "pi-file";
    }
  },
  linkIcon(link) {
    if(link==null) {
      return "pi-ban";
      // pi-external-link
    }
    if(link.includes('www.youtube.com')) {
      return "pi-youtube";
    } else {
      return "pi-video";
    }
  },
  timeAgo(date) {
    // how many hours or days ago using insertDate (ie. 8 hours ago, 15 days ago)
    if(date==null) {
      return "";
    }
    const now = new Date();
    const diff = now - new Date(date);
    const hours = Math.floor(diff / 1000 / 60 / 60);
    const days = Math.floor(hours / 24);
    if(days > 0) {
      return `${days} ${days === 1 ? 'day' : 'days'} ago`;
    } else {
      return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    }
  },
  currencies() {
    return {
      "USD": "$",   // Dollaro statunitense
      "EUR": "€",   // Euro
      "JPY": "¥",   // Yen giapponese
      "GBP": "£",   // Sterlina britannica
      "BRL": "$",   // Real brasiliano
      "COP": "$",   // Peso colombiano
      "CLP": "$",   // Peso cileno
      "MXN": "$",   // Peso messicano
      "ARS": "$",   // Peso argentino
      "CHF": "Fr",  // Franco svizzero
      "DKK": "kr",  // Corona danese
      "SAR": "SR",  // Rial saudita
      "TWD": "$",   // Nuovo dollaro di Taiwan
      "SGD": "$",   // Dollaro di Singapore
      "AED": "د.إ", // Dirham degli Emirati Arabi Uniti
      "THB": "฿",   // Baht thailandese
      "CRC": "₡",   // Colón costaricano
      "PEN": "S",   // Sol peruviano
      "KRW": "₩",   // Won sudcoreano
      "PHP": "₱",   // Peso filippino
      "VES": "BS",  // Bolívar venezuelano
      "GTQ": "Q",   // Quetzal guatemalteco
      "AUD": "$",   // Dollaro australiano
      "CAD": "$",   // Dollaro canadese
      "PLN": "zł",  // Złoty polacco
      "NZD": "$",   // Dollaro neozelandese
      "CZK": "Kč",  // Corona ceca 
      "SEK": "kr",  // Corona svedese
      "NOK": "kr",  // Corona norvegese
      "INR": "₹",   // Rupia indiana
      "IDR": "Rp"   // Rupia indonesiana
    };
  },
  currencyOpt(currency) {
    const isZeroDecimal = zeroDecimalCurrencies.includes(currency);
    if(isZeroDecimal) {
      return { minimumFractionDigits: 0, maximumFractionDigits: 0 };
    }
    return {};
  },
  newsLanguages(locale) {
    switch(locale) {
      case "de_DE":
      case "de":
        return "de_ww";
      case "nl_NL":
      case "nl":
        return "nl_ww";
      case "en_GB":
      case "en":
        return "en_ww";
      case "es_ES":
      case "es":
        return "es_ww";
      case "fr_FR":
      case "fr":
        return "fr_ww";
      case "it_IT":
      case "it":
        return "it_ww";
      case "ru_RU":
      case "ru":
        return "en_ww";
      case "en_US":
        return "en_us";
      case "ja_JP":
      case "ja":
        return "en_ja";
      case "pt_BR":
      case "pt":
        return "pt_br";
      case "ko_KR":
      case "ko":
        return "en_kr";
      case "hi_IN":
      case "hi":
        return "en_ww";
      case "id_ID":
      case "id":
        return "en_ww";
      case "zh_CN":
      case "zh":
        return "en_ww";
      default:
        return "en_ww";
    }},

    copy(text) {
      navigator.clipboard.writeText(text).then(function() {
        // console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }
